import { getData } from "../../api";

export const getSingleData = async (selected) => {
  try {
    let url = `/dashboard/dashboard?type=${selected}`;

    return await getData(url);
  } catch (error) {
    console.error(error);
  }
};

export const getAllData = async (selected) => {
  try {
    let url = `/dashboard/dashboard/all?type=${selected}`;

    return await getData(url);
  } catch (error) {
    console.error(error);
  }
};

// export const getSingleData = async () => {
//   try {
//     return await getData(`/admin/investors/investors`);
//   } catch (error) {
//     console.error(error);
//   }
// };
